import { Injectable } from '@angular/core';
import { get } from 'scriptjs';
import environment from 'src/environments/environment';
import { ApiService } from './api.service';
import { AuthService } from './auth.service';

declare let AppleID: any;

@Injectable({
  providedIn: 'root',
})
export class AppleLoginService {
  private readonly appleScriptUrl: string =
    'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';

  private ready: Promise<boolean> = new Promise((resolve) => {
    if (typeof window !== 'undefined') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      get(this.appleScriptUrl, () => resolve(true));
    } else {
      resolve(false);
    }
  });

  constructor(
    private readonly api: ApiService,
    private readonly auth: AuthService
  ) {
    this.ready
      .then((isReady) => {
        if (isReady) {
          this.init();
        }
      })
      .catch(() => {})
      .finally(() => {});
  }

  private init(): void {
    // eslint-disable-next-line
    AppleID.auth.init({
      clientId: environment.apple.client_id,
      scope: environment.apple.scope,
      redirectURI: environment.apple.redirect_uri,
      usePopup: true,
    });
  }

  public signIn(): Promise<any> {
    // eslint-disable-next-line
    return AppleID.auth.signIn();
  }
}
